import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { MyPortfolioService } from 'src/app/features/portfolio/services/my-portfolio.service';
import { Role, SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { PermissionsState } from 'src/app/stores/access-control/access-control.reducers';
import { PortfolioService } from '../../services/portfolio.service';
import { SharedService } from '../../services/shared.service';
import { SubscriptionService } from '../../services/subscription.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-unlock-broker-popup',
    templateUrl: './unlock-broker-popup.component.html',
    styleUrls: ['./unlock-broker-popup.component.scss'],
    standalone: false
})
export class UnlockBrokerPopupComponent implements OnInit {
   private destroy$: Subject<void> = new Subject<void>();
   userNewRole: Role = null;
   maxManualPortfoliosCount: number = 0;
   maxBrokeragePortfoliosCount: number = 0;
   currentManualPortfoliosCount: number = 0;
   currentBrokeragePortfoliosCount: number = 0;

   constructor(
      private sharedService: SharedService,
      private portfolioService: PortfolioService,
      private permissionStore: Store<{ permissions: PermissionsState }>,
      private myPortolioService: MyPortfolioService,
      private router: Router,
      public subscriptionService: SubscriptionService
   ) { }

   ngOnInit(): void {
      this.permissionStore.select(({ permissions }) => permissions.permissions).pipe(takeUntil(this.destroy$)).subscribe((permissions) => {
         this.maxManualPortfoliosCount = permissions.manual_portfolio_count;
         this.maxBrokeragePortfoliosCount = permissions.brokerage_connected_portfolios_count;

      })

      SubscriptionService.subscriptionData.pipe(takeUntil(this.destroy$)).subscribe((data: SubscriptionInfoModel) => {
         this.userNewRole = data.newRole;
      });

      // this.getAccountsCount()
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }

   getAccountsCount() {
      this.portfolioService.getAccountCounts().pipe(takeUntil(this.destroy$)).subscribe((data) => {
         this.currentManualPortfoliosCount = data.manual_connected_count > this.maxManualPortfoliosCount ? this.maxManualPortfoliosCount : data.manual_connected_count;
         this.currentBrokeragePortfoliosCount = data.brokerage_connected_count > this.maxBrokeragePortfoliosCount ? this.maxBrokeragePortfoliosCount : data.brokerage_connected_count;
      })
   }

   openBrokeragesPopup() {
      this.portfolioService.closeUnlockBrokeragePopup();
      this.router.navigate(['/pricing'])
      // this.portfolioService.closeConnectPortfolioPopup()

      // if (this.currentBrokeragePortfoliosCount >= this.maxBrokeragePortfoliosCount) {
      //    this.sharedService.openUpgradePopup('portfolio');
      // } else {
      //    this.portfolioService.openSupportedBrokeragesModal(true);
      // }
   }

   openManualPopup() {
      this.portfolioService.closeConnectPortfolioPopup()

      if (this.currentManualPortfoliosCount < this.maxManualPortfoliosCount) {
         this.myPortolioService.openCreateManualPortfolioPopup();
      } else {
         this.portfolioService.openMessagePopup('manual')
      }
   }

   closeConnectPopup() {
      this.portfolioService.closeUnlockBrokeragePopup()
   }
}
